import pro1 from "../assets/pro.jpg";


const ProjectCardData = [
    {
        imgsrc: pro1,
        title: "Cv Builder web app",
        text: "Cree facilement ton cv!",
        view: "https://bethel03.github.io/cv-builder/",
        source: "https://github.com/Bethel03/cv-builder"
    },

    {
        imgsrc: pro1,
        title: "Morse-Converter",
        text: "Encode/decode en morse.",
        view: "",
        source: "https://github.com/Bethel03/Morse-Converter",
    },
    {
        imgsrc: pro1,
        title: "Qr Code Generator",
        text: "Genere  ton Qr Code.",
        view: "https://bethel03.github.io/Qr_generator/",
        source: "https://github.com/Bethel03/Qr_generator",
    }

    
];

export default ProjectCardData;